import React, { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import axios from '../api/client';
import { useAuth } from '../contexts/AuthContext';
import { API } from '../api/config';

const OAuthCallback: React.FC = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { getCurrentUser } = useAuth();
  
  useEffect(() => {
    const handleCallback = async () => {
      try {
        const code = searchParams.get('code');
        const state = searchParams.get('state');
        const provider = window.location.pathname.includes('google') ? 'google' : 'github';
        
        if (!code) {
          throw new Error('No authorization code received');
        }
        
        const callbackUrl = provider === 'google'
          ? API.callbackGoogle()
          : API.callbackGithub();

        const response = await axios.post(callbackUrl, { code, state });

        localStorage.setItem('access_token', response.data.access_token);
        if (response.data.refresh_token) {
          localStorage.setItem('refresh_token', response.data.refresh_token);
        }

        await getCurrentUser();
        navigate('/dashboard');
      } catch (error) {
        console.error('OAuth callback failed:', error);
        navigate('/login?error=oauth_failed');
      }
    };
    
    handleCallback();
  }, [searchParams, navigate, getCurrentUser]);
  
  return <div>Processing authentication...</div>;
};

export default OAuthCallback;
